import { Directive, inject } from '@angular/core';
import { AccountService } from '@infodocs/shared/services/account.service';
import { CompanyPreviewComponent } from '@infodocs/portfolio/modals/company-preview/company-preview.component';
import type { CompanyAddSearchLabel } from '@infodocs/portfolio/services/company-added-journey-logger.service';
import { HasObservablesComponent } from '@infodocs/shared/has-observables.component';
import { CompanySearchResult } from '@infodocs/shared/interfaces/company-search-result';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Directive()
export default abstract class SearchesForCompaniesComponent extends HasObservablesComponent {
	protected readonly accountService = inject(AccountService);
	protected readonly modalRef = inject(BsModalRef);
	protected readonly modalService = inject(BsModalService);
	protected abstract onBack(): void;
	// Plain property: set via ngx-bootstrap modalService.show initialState (Object.assign overwrites signals).
	public onFlowComplete: () => void = () => { };

	// fetch and display the selected company's data
	protected previewCompany(company: CompanySearchResult) {
		this.modalRef.hide();

		return this.modalService.show(CompanyPreviewComponent, {
			initialState: {
				registrationNumber: company.CompanyInformation.CompanyRegistrationNumber,
				companyExists: company.CompanyExists ?? company.CompanyInformation.CompanyExists,
				existingCompanyId: company.CompanyInformation.CompanyId,
				companySearchResult: company,
				search_option: this.getSearchOption(),
				onBack: () => this.onBack(),
				onFlowComplete: () => this.onFlowComplete(),
			}
		});
	}

	protected requestAccess(company: CompanySearchResult) {
		company.CompanyInformation.uxHasRequestedAccessToCompany = 'pending';
		this.accountService
			.requestAccessToCompany(company.CompanyInformation.CompanyRegistrationNumber)
			.subscribe((result: any) => {
				company.CompanyInformation.uxHasRequestedAccessToCompany = 'requested';
			});
	}

	protected getSearchOption(): CompanyAddSearchLabel {
		return 'Company Search';
	}
}
